import { regex } from '@plug/helpers/hubly-form';
import { YUP_VALIDATIONS } from '@plug/helpers/yup-helpers';
import i18n from '@plug/i18n';
import * as Yup from 'yup';

export const AffiliateRegisterPersonalDataSchemaWithCustomFields = (
  requirements: IAppRequirement[],
  values: Omit<IWhitelabelCustomization, 'organizationId'>,
) => {
  return Yup.object().shape(
    values.onboarding.fields.reduce((prev, curr) => {
      const field = requirements.find(item => item.value === curr.key);

      if (!field) return prev;

      const additionalFields = JSON.parse(field.additionalFields || '{}');

      let rules = field.required
        ? Yup.string().required(i18n.t('hubly-dashboard.commons.form.errors.commons.required'))
        : Yup.string();

      if (additionalFields?.regex) {
        rules = rules.matches(
          regex(additionalFields?.regex),
          'Campo inválido, verifique e tente novamente, por favor.',
        );
      }

      return {
        ...prev,
        [curr.key]: rules,
      };
    }, {}),
  );
};

export const AffiliateRegisterPersonalDataSchemaCPF = (requiredPhone: boolean) =>
  Yup.object().shape({
    name: YUP_VALIDATIONS.name,
    email: YUP_VALIDATIONS.email,
    document: YUP_VALIDATIONS.document,
    phone: YUP_VALIDATIONS.phone.when([], {
      is: () => requiredPhone === true,
      then: schema =>
        schema.required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),
      otherwise: schema => schema.notRequired(),
    }),
  });

export const AffiliateRegisterPersonalDataSchemaCNPJ = (requiredPhone: boolean) =>
  Yup.object().shape({
    name: YUP_VALIDATIONS.name,
    email: YUP_VALIDATIONS.email,
    document: YUP_VALIDATIONS.cnpj,
    phone: YUP_VALIDATIONS.phone.when([], {
      is: () => requiredPhone === true,
      then: schema =>
        schema.required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),
      otherwise: schema => schema.notRequired(),
    }),
  });
